import EthMintButton from "../Mint/EthMintButton";
import TonMintButton from "../Mint/TonMintButton";
import Web2BuyButton from "../Mint/Web2BuyButton";
import "./style.scss";
import { useTonAddress, useTonConnectUI } from "@tonconnect/ui-react";
import { useCallback } from "react";
import { useAccount } from "wagmi";

interface ITxForm {
  color: string;
  username: string;
}

export function TxForm({ color, username }: ITxForm) {
  const address = useTonAddress(false);
  const [tonConnectUI] = useTonConnectUI();
  const { isConnected } = useAccount();

  const BuyButton = useCallback(() => {
    if (tonConnectUI.connected) {
      return <TonMintButton color={color} />;
    } else if (username) {
      return <Web2BuyButton color={color} username={username} />;
    } else if (isConnected) {
      return <EthMintButton color={color} />;
    }
  }, [address, username, isConnected, color]);

  return (
    <div className="buy-buttons" style={{ textAlign: "center" }}>
      <BuyButton />
    </div>
  );
}
